import { render } from "./user-contacts.vue?vue&type=template&id=79f45c72&scoped=true&ts=true"
import script from "./user-contacts.vue?vue&type=script&lang=ts"
export * from "./user-contacts.vue?vue&type=script&lang=ts"

import "./user-contacts.vue?vue&type=style&index=0&id=79f45c72&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f45c72"]])

export default __exports__